import { handleGetListResponse } from '../helpers/HandleGetListResponse';

export const handleGetListResponseForm = ({
  id,
  setLoading,
  setError,
  setListResponse,
  navigate
}) => {
  setLoading(true);
  const { error } = handleGetListResponse(id, setListResponse);
  if (error) setError(error);
  setLoading(false);
  navigate(`/form/response-list/${id}`);
};
